var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _path, _polygon, _path2, _polygon2, _path3, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQrcode = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 2000 2000",
    x: 0,
    y: 0,
    shapeRendering: "crispEdges",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 815,
    y: 223,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 963,
    y: 223,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1037,
    y: 223,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1111,
    y: 223,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 963,
    y: 297,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1037,
    y: 297,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 815,
    y: 371,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 889,
    y: 371,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1037,
    y: 371,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 815,
    y: 445,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 889,
    y: 445,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1111,
    y: 445,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 815,
    y: 519,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1037,
    y: 519,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 889,
    y: 593,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 963,
    y: 593,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 1037,
    y: 593,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1111,
    y: 593,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 815,
    y: 667,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 963,
    y: 667,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 1111,
    y: 667,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 1037,
    y: 741,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 1111,
    y: 741,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 815,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 815,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 371,
    y: 815,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 815,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 667,
    y: 815,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 815,
    y: 815,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 889,
    y: 815,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 963,
    y: 815,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 1037,
    y: 815,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 1111,
    y: 815,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 1185,
    y: 815,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 1407,
    y: 815,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 1481,
    y: 815,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 1555,
    y: 815,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 1703,
    y: 815,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 889,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 371,
    y: 889,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 593,
    y: 889,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 741,
    y: 889,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 1037,
    y: 889,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 1111,
    y: 889,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 1185,
    y: 889,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 1259,
    y: 889,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 1333,
    y: 889,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 1481,
    y: 889,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 1555,
    y: 889,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 1629,
    y: 889,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 963,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 963,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 667,
    y: 963,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 741,
    y: 963,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 815,
    y: 963,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 889,
    y: 963,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 1037,
    y: 963,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 1481,
    y: 963,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 1555,
    y: 963,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 1629,
    y: 963,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 1703,
    y: 963,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 1037,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 371,
    y: 1037,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 1037,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 593,
    y: 1037,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 741,
    y: 1037,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 815,
    y: 1037,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 889,
    y: 1037,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 963,
    y: 1037,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 1037,
    y: 1037,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 1259,
    y: 1037,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 1407,
    y: 1037,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 1481,
    y: 1037,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 1629,
    y: 1037,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 371,
    y: 1111,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 1111,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 519,
    y: 1111,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 593,
    y: 1111,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 667,
    y: 1111,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 815,
    y: 1111,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 889,
    y: 1111,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 963,
    y: 1111,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 1111,
    y: 1111,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 1333,
    y: 1111,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 1481,
    y: 1111,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 1555,
    y: 1111,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 815,
    y: 1185,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 1037,
    y: 1185,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 1259,
    y: 1185,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 1703,
    y: 1185,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 963,
    y: 1259,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 1037,
    y: 1259,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 1111,
    y: 1259,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 889,
    y: 1333,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 963,
    y: 1333,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 1333,
    y: 1333,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 1407,
    y: 1333,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 1555,
    y: 1333,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 1703,
    y: 1333,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 889,
    y: 1407,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 1111,
    y: 1407,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 1185,
    y: 1407,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 1259,
    y: 1407,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 1333,
    y: 1407,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 1555,
    y: 1407,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 815,
    y: 1481,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 889,
    y: 1481,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 963,
    y: 1481,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 1037,
    y: 1481,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 1259,
    y: 1481,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 1333,
    y: 1481,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 1481,
    y: 1481,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 815,
    y: 1555,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 963,
    y: 1555,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 1111,
    y: 1555,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 1259,
    y: 1555,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 1333,
    y: 1555,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 815,
    y: 1629,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 889,
    y: 1629,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 1185,
    y: 1629,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 1333,
    y: 1629,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 1407,
    y: 1629,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 1481,
    y: 1629,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 1629,
    y: 1629,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 815,
    y: 1703,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 1185,
    y: 1703,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 1333,
    y: 1703,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 1407,
    y: 1703,
    width: 74,
    height: 74,
    fill: "#fff"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 1481,
    y: 1703,
    width: 74,
    height: 74,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 223,
    y: 223,
    width: 518,
    height: 518,
    viewBox: "0 0 699.988 699.986",
    enableBackground: "new 0 0 699.988 699.986",
    xmlSpace: "preserve",
    shapeRendering: "auto",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M600.99,0h-100h-99.997h-0.001h-99.997h-99.998h-99.998H1v99.998v99.998v99.998v99.999v99.997v99.998v99.998  h99.999h99.998h99.998h99.997h0.001h99.997h100h99.998v-99.998V499.99v-99.997v-99.999v-99.998V99.998V0H600.99z M600.99,199.996  v99.998v99.999v99.997v99.998h-100h-99.997h-0.001h-99.997h-99.998h-99.998V499.99v-99.997v-99.999v-99.998V99.998h99.998h99.998  h99.997h0.001h99.997h100V199.996z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 223,
    y: 223,
    width: 518,
    height: 518,
    viewBox: "0 0 699.988 699.988",
    enableBackground: "new 0 0 699.988 699.988",
    xmlSpace: "preserve",
    shapeRendering: "auto",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "399.994,199.997 399.992,199.997 299.996,199.997 199.998,199.997 199.998,299.994 199.998,399.994   199.998,499.991 299.996,499.991 399.992,499.991 399.994,499.991 499.99,499.991 499.99,399.994 499.99,299.994 499.99,199.997 "
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 1259,
    y: 223,
    width: 518,
    height: 518,
    viewBox: "0 0 699.988 699.986",
    enableBackground: "new 0 0 699.988 699.986",
    xmlSpace: "preserve",
    shapeRendering: "auto",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M600.99,0h-100h-99.997h-0.001h-99.997h-99.998h-99.998H1v99.998v99.998v99.998v99.999v99.997v99.998v99.998  h99.999h99.998h99.998h99.997h0.001h99.997h100h99.998v-99.998V499.99v-99.997v-99.999v-99.998V99.998V0H600.99z M600.99,199.996  v99.998v99.999v99.997v99.998h-100h-99.997h-0.001h-99.997h-99.998h-99.998V499.99v-99.997v-99.999v-99.998V99.998h99.998h99.998  h99.997h0.001h99.997h100V199.996z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 1259,
    y: 223,
    width: 518,
    height: 518,
    viewBox: "0 0 699.988 699.988",
    enableBackground: "new 0 0 699.988 699.988",
    xmlSpace: "preserve",
    shapeRendering: "auto",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "399.994,199.997 399.992,199.997 299.996,199.997 199.998,199.997 199.998,299.994 199.998,399.994   199.998,499.991 299.996,499.991 399.992,499.991 399.994,499.991 499.99,499.991 499.99,399.994 499.99,299.994 499.99,199.997 "
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 223,
    y: 1259,
    width: 518,
    height: 518,
    viewBox: "0 0 699.988 699.986",
    enableBackground: "new 0 0 699.988 699.986",
    xmlSpace: "preserve",
    shapeRendering: "auto",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M600.99,0h-100h-99.997h-0.001h-99.997h-99.998h-99.998H1v99.998v99.998v99.998v99.999v99.997v99.998v99.998  h99.999h99.998h99.998h99.997h0.001h99.997h100h99.998v-99.998V499.99v-99.997v-99.999v-99.998V99.998V0H600.99z M600.99,199.996  v99.998v99.999v99.997v99.998h-100h-99.997h-0.001h-99.997h-99.998h-99.998V499.99v-99.997v-99.999v-99.998V99.998h99.998h99.998  h99.997h0.001h99.997h100V199.996z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 223,
    y: 1259,
    width: 518,
    height: 518,
    viewBox: "0 0 699.988 699.988",
    enableBackground: "new 0 0 699.988 699.988",
    xmlSpace: "preserve",
    shapeRendering: "auto",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "399.994,199.997 399.992,199.997 299.996,199.997 199.998,199.997 199.998,299.994 199.998,399.994   199.998,499.991 299.996,499.991 399.992,499.991 399.994,499.991 499.99,499.991 499.99,399.994 499.99,299.994 499.99,199.997 "
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQrcode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/qrcode.ee38a1e6a47e10fff448337f953c818e.svg";